import { useState, useEffect, useRef } from "react";
import { Box, Typography, Avatar, Chip, useMediaQuery, useTheme, Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  AiOutlinePlayCircle,
  AiOutlineShareAlt,
  AiOutlineComment,
} from "react-icons/ai";
import { IoVolumeMute, IoVolumeHigh } from "react-icons/io5";
import { BiExpand, BiCollapse } from "react-icons/bi";
import { MdAccessTime, MdPerson } from "react-icons/md";
import { DeleteOutline, VideoLibrary, Warning } from "@mui/icons-material";
import { Client, Databases, Storage, Query } from "appwrite";

const MyUploads = () => {
  const [posts, setPosts] = useState([]);
  const navigate = useNavigate();
  const { userId } = useParams();
  const token = useSelector((state) => state.token);
  const user = useSelector((state) => state.user);
  const currentUserId = user?._id;
  const [loading, setLoading] = useState(true);
  const [videoStates, setVideoStates] = useState({});
  const videoRefs = useRef({});
  const videoContainerRefs = useRef({});
  const progressBarRefs = useRef({});
  // const [profileUser, setProfileUser] = useState(null);
  // const [isFollowing, setIsFollowing] = useState(false);

  // State for delete confirmation dialog
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [postToDelete, setPostToDelete] = useState(null);
  

   // Add Appwrite client setup
   const client = new Client();
   client
     .setEndpoint(process.env.REACT_APP_APPWRITE_ENDPOINT)
     .setProject(process.env.REACT_APP_APPWRITE_PROJECT_ID);
 
   const databases = new Databases(client);
   const storage = new Storage(client);
 
   // Constants for Appwrite
const DATABASE_ID = "681f7caf0033c79e0bc0";
const COLLECTION_ID = "681f80c000210a12ef65";
const FOLLOWERS_COLLECTION_ID = "681f7e8e0028ee01df31";
   const BUCKET_ID = process.env.REACT_APP_APPWRITE_BUCKET_ID;
  
  // Add theme for responsive design
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'));

   // Check if current user follows the profile user
  //  const checkFollowStatus = async () => {
  //   if (!currentUserId || !userId || currentUserId === userId) {
  //     return false;
  //   }

  //   try {
  //     const followResponse = await databases.listDocuments(
  //       DATABASE_ID,
  //       FOLLOWERS_COLLECTION_ID,
  //       [
  //         Query.equal("followerId", currentUserId),
  //         Query.equal("followedId", userId)
  //       ]
  //     );
      
  //     return followResponse.documents.length > 0;
  //   } catch (error) {
  //     console.error("Error checking follow status:", error);
  //     return false;
  //   }
  // };

  
  // Fetch the profile user's data
  // const fetchProfileUser = async () => {
  //   try {
  //     const response = await fetch(`http://localhost:3001/users/${userId}`, {
  //       method: "GET",
  //       headers: { Authorization: `Bearer ${token}` },
  //     });

  //     if (!response.ok) throw new Error("Failed to fetch user data");
  //     const userData = await response.json();
  //     setProfileUser(userData);
  //   } catch (error) {
  //     console.error("Error fetching profile user:", error);
  //   }
  // };

  

  // useEffect(() => {
  //   const loadData = async () => {
  //     setLoading(true);
      
  //     // If viewing own profile or other user's profile
  //     if (userId) {
  //       await fetchProfileUser();
        
  //       // Check if current user follows this profile user
  //       const following = await checkFollowStatus();
  //       setIsFollowing(following);
        
  //       // Fetch posts for this user if it's your profile OR you follow them
  //       if (userId === currentUserId || following) {
  //         try {
  //           const response = await fetch(`http://localhost:3001/posts/${userId}/posts`, {
  //             method: "GET",
  //             headers: { Authorization: `Bearer ${token}` },
  //           });
  //           const data = await response.json();
  //           setPosts(data);
  //         } catch (error) {
  //           console.error("Error fetching posts:", error);
  //           setPosts([]);
  //         }
  //       } else {
  //         // If you don't follow this user, show no posts
  //         setPosts([]);
  //       }
  //     }
      
  //     setLoading(false);
  //   };

  //   loadData();
  // }, [userId, currentUserId, token]);

  // Format time to MM:SS or HH:MM:SS
  const formatTime = (seconds) => {
    if (isNaN(seconds) || seconds === Infinity) return "00:00";
    
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = Math.floor(seconds % 60);
    
    if (hours > 0) {
      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    }
    
    return `${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

 // Replace the useEffect for fetching user posts
 useEffect(() => {
  const fetchUserPosts = async () => {
    try {
      setLoading(true);
      // Query Appwrite for posts by this user
      const response = await databases.listDocuments(
        DATABASE_ID,
        COLLECTION_ID,
        [
          Query.equal('userId', userId),
          Query.orderDesc('createdAt')
        ]
      );
      
      // Transform Appwrite data to match your post structure
      const userPosts = response.documents.map(doc => {
        // Generate the video file URL
        const videoUrl = storage.getFileView(
          BUCKET_ID,
          doc.fileId
        );

        return {
          _id: doc.$id,
          description: doc.description,
          videoPath: videoUrl, // This will be a direct URL now
          talent: doc.talent,
          createdAt: doc.createdAt,
          hashtags: doc.hashtags || [],
          // Add other fields as needed
        };
      });
      
      setPosts(userPosts);
      
      // Initialize video states
      const initialStates = userPosts.reduce((acc, post) => {
        acc[post._id] = {
          playing: false,
          muted: true,
          isFullscreen: false,
          progress: 0,
          duration: 0,
          currentTime: 0
        };
        return acc;
      }, {});
      
      setVideoStates(initialStates);
    } catch (error) {
      // console.error("Error fetching user posts:", error);
    } finally {
      setLoading(false);
    }
  };
  
  if (userId) {
    fetchUserPosts();
  }
}, [userId]);

  // Match the fullscreen change event listener
  useEffect(() => {
    const handleFullscreenChange = () => {
      if (!document.fullscreenElement) {
        // Reset all fullscreen states when exiting
        setVideoStates(prev => {
          const newStates = {...prev};
          Object.keys(newStates).forEach(id => {
            newStates[id] = {...newStates[id], isFullscreen: false};
          });
          return newStates;
        });
      }
    };
    
    document.addEventListener("fullscreenchange", handleFullscreenChange);
    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
    };
  }, []);

  // Video playback controls - Only used for displaying previews, not for main interaction
  const handlePlayPause = (postId, e) => {
    if (e) {
      e.stopPropagation(); // Prevent the click from reaching parent containers
    }
    
    if (!videoRefs.current[postId]) return;
    
    const videoElement = videoRefs.current[postId];
    const isCurrentlyPlaying = videoStates[postId]?.playing || false;
    
    if (isCurrentlyPlaying) {
      videoElement.pause();
    } else {
      // Pause all other videos first
      Object.keys(videoRefs.current).forEach((id) => {
        if (id !== postId && videoRefs.current[id]) {
          videoRefs.current[id].pause();
        }
      });
      
      videoElement.play();
    }
    
    setVideoStates(prev => ({
      ...prev,
      [postId]: { ...prev[postId], playing: !isCurrentlyPlaying }
    }));
  };

  // Toggle mute function - Updated to apply to all videos
  const toggleMute = (postId, e) => {
    if (e) {
      e.stopPropagation(); // Prevent the click from reaching the video element
    }
    
    if (!videoRefs.current[postId]) return;
    
    // Get current muted state from the clicked video
    const currentMutedState = videoStates[postId]?.muted;
    const newMutedState = !currentMutedState;
    
    // Apply the new muted state to all videos
    Object.keys(videoRefs.current).forEach(id => {
      if (videoRefs.current[id]) {
        videoRefs.current[id].muted = newMutedState;
      }
    });
    
    // Update all video states at once
    setVideoStates(prev => {
      const newStates = {...prev};
      Object.keys(newStates).forEach(id => {
        newStates[id] = {...newStates[id], muted: newMutedState};
      });
      return newStates;
    });
  };
// In MyUploads component in uploadedVideos.jsx
// useEffect(() => {
//   const initialize = async () => {
//     // Check follow status first if needed
//     const followStatus = await checkFollowStatus();
//     setIsFollowing(followStatus);
    
//     // Fetch user data for the profile being viewed
//     if (userId !== currentUserId) {
//       try {
//         const response = await fetch(`http://localhost:3001/users/${userId}`, {
//           method: "GET",
//           headers: { Authorization: `Bearer ${token}` },
//         });
        
//         if (response.ok) {
//           const userData = await response.json();
//           setProfileUser(userData);
//         }
//       } catch (error) {
//         console.error("Error fetching profile user:", error);
//       }
//     }
//   };
  
//   initialize();
// }, [userId, currentUserId]);
  // Fullscreen implementation
  const toggleFullscreen = (postId, e) => {
    if (e) {
      e.stopPropagation(); // Prevent the click from redirecting
    }
    
    if (!videoContainerRefs.current[postId]) return;
    
    const el = videoContainerRefs.current[postId];
    
    if (!document.fullscreenElement) {
      el.requestFullscreen?.().then(() => {
        setVideoStates(prev => ({
          ...prev,
          [postId]: { ...prev[postId], isFullscreen: true }
        }));
      }).catch(err => {
        // console.error(`Error attempting to enable fullscreen: ${err.message}`);
      });
    } else {
      document.exitFullscreen?.().then(() => {
        setVideoStates(prev => ({
          ...prev,
          [postId]: { ...prev[postId], isFullscreen: false }
        }));
      }).catch(err => {
        // console.error(`Error attempting to exit fullscreen: ${err.message}`);
      });
    }
  };

  // Update progress as video plays
  const handleTimeUpdate = (postId) => {
    const video = videoRefs.current[postId];
    if (!video) return;

    const progress = (video.currentTime / video.duration) * 100;
    setVideoStates(prev => ({
      ...prev,
      [postId]: {
        ...prev[postId],
        currentTime: video.currentTime,
        progress: progress
      }
    }));
  };

  // Seek video when user clicks on the progress bar
  const handleProgressClick = (e, postId) => {
    e.stopPropagation(); // Prevent navigation when clicking progress bar
    
    if (!progressBarRefs.current[postId] || !videoRefs.current[postId]) return;
    
    const bar = progressBarRefs.current[postId];
    const videoElement = videoRefs.current[postId];
    
    const rect = bar.getBoundingClientRect();
    const clickX = e.clientX - rect.left;
    const width = rect.width;

    const percentage = clickX / width;
    const newTime = videoElement.duration * percentage;
    videoElement.currentTime = newTime;
  };

  // Handler for when video metadata loads
 // Video handling functions

  const handleMetadataLoaded = (postId) => {
    const video = videoRefs.current[postId];
    if (!video) return;

    setVideoStates(prev => ({
      ...prev,
      [postId]: {
        ...prev[postId],
        duration: video.duration,
        currentTime: 0,
        progress: 0,
        playing: false,
        muted: true
      }
    }));
  };

  // Open delete confirmation dialog
  const openDeleteDialog = (postId, e) => {
    if (e) {
      e.stopPropagation(); // Prevent navigation when clicking delete
    }
    setPostToDelete(postId);
    setDeleteDialogOpen(true);
  };

  // Close delete confirmation dialog
  const closeDeleteDialog = () => {
    setDeleteDialogOpen(false);
    setPostToDelete(null);
  };

  // Perform the actual deletion after confirmation
  const confirmDelete = async () => {
    if (!postToDelete) return;
    
    try {
      // Get the document to find the file ID before deleting
      const document = await databases.getDocument(
        DATABASE_ID,
        COLLECTION_ID,
        postToDelete
      );
      
      // Delete the document from the database
      await databases.deleteDocument(
        DATABASE_ID,
        COLLECTION_ID,
        postToDelete
      );
      
      // If there's a file associated, delete it too
      if (document.fileId) {
        await storage.deleteFile(
          BUCKET_ID,
          document.fileId
        );
      }
      
      // Update the state to remove the deleted post
      setPosts(prevPosts => prevPosts.filter(post => post._id !== postToDelete));
      
      // Optional: Show success notification
      // toast.success("Video deleted successfully");
      
    } catch (error) {
      // console.error("Error deleting post:", error);
      // Optional: Show error notification
      // toast.error("Failed to delete video");
    } finally {
      // Close the dialog
      closeDeleteDialog();
    }
  };

  // Navigate to post detail - This is now the main click handler for videos
  const handlePostClick = (postId) => {
    navigate(`/home/post/${postId}?source=shared`);
  };

  // Get video card width based on screen size
  const getVideoCardWidth = () => {
    if (isMobile) return "100%";
    if (isTablet) return "45%";
    if (isLargeScreen) return "23%";
    return "30%"; // Default (medium screens)
  };

  

  return (
    <Box sx={{ 
      overflowX: "hidden", 
      backgroundColor: "white",
      minHeight: "100vh"
    }}>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          pt: { xs: 2, sm: 3, md: 0 },
          pb: { xs: 4, sm: 6, md: 8 },
          px: { xs: 2, sm: 3, md: 4 },
          minHeight: "100vh",
          flexDirection: "column",
          alignItems: "center",
          gap: { xs: 2, sm: 3, md: 4 },
          marginLeft: { xs: 0, sm: 0, md: "130px" }, // Shifted left from 220px to 180px
          transition: "all 0.3s ease",
          backgroundColor: "#ffffff",
          backgroundImage: "radial-gradient(#f0f0f0 1px, transparent 1px)",
          backgroundSize: "20px 20px"
        }}
      >
        <Box sx={{ 
          textAlign: "center", 
          mb: { xs: 2, sm: 3, md: 4 },
          width: "100%",
          maxWidth: "1200px"
        }}>
          <Typography 
            variant="h5" 
            sx={{ 
              fontWeight: 700, 
              fontSize: { xs: "1.5rem", sm: "1.75rem", md: "2rem" },
              color: "#333",
              mb: 1,
              position: "relative",
              display: "inline-block"
            }}
          >
            <Box sx={{
              position: "relative",
              "&::after": {
                content: '""',
                position: "absolute",
                bottom: "-8px",
                left: "50%",
                transform: "translateX(-50%)",
                width: "60px",
                height: "4px",
                background: "linear-gradient(to right, #F02C56, #8B5CF6)",
                borderRadius: "2px"
              }
            }}>
           <VideoLibrary sx={{ mr: 1, verticalAlign: "text-bottom" }} />
              Your Uploaded Videos
            </Box>
          </Typography>
        </Box>
        
        {loading ? (
          <Box sx={{ 
            display: "flex", 
            justifyContent: "center", 
            alignItems: "center", 
            height: "300px",
            width: "100%"
          }}>
            <Typography sx={{ 
              fontSize: { xs: "1rem", sm: "1.1rem" }, 
              color: "#666",
              fontWeight: 500
            }}>
              Loading your videos...
            </Typography>
          </Box>
       
        ) : posts.length === 0 ? (
          <Box sx={{ 
            textAlign: "center", 
            py: 8, 
            px: 2, 
            borderRadius: 4,
            bgcolor: "rgba(0,0,0,0.02)",
            border: "1px dashed #ddd",
            width: "100%",
            maxWidth: "600px"
          }}>
           <Typography variant="h6" sx={{ color: "#555", mb: 2 }}>
              No videos uploaded yet
            </Typography>
            <Typography variant="body2" sx={{ color: "#777" }}>
              Start creating and sharing your talent with the world
            </Typography>
          </Box>
        ) : (
          <Box 
            sx={{ 
              display: "flex", 
              flexWrap: "wrap",
              justifyContent: { xs: "center", sm: "flex-start" },
              gap: { xs: 2, sm: 3, md: 3 },
              width: "100%",
              maxWidth: "1500px",
              px: { xs: 1, sm: 2, md: 3 }
            }}
          >
            {posts.map((post) => (
              <Box
                key={post._id}
                sx={{
                  bgcolor: "white",
                  boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
                  borderRadius: "16px",
                  width: getVideoCardWidth(),
                  minWidth: { xs: "240px", sm: "260px", md: "280px" },
                  maxWidth: { xs: "100%", sm: "280px", md: "300px" },
                  p: { xs: 1.5, sm: 2, md: 2.5 },
                  position: "relative",
                  transition: "all 0.3s cubic-bezier(0.165, 0.84, 0.44, 1)",
                  "&:hover": {
                    transform: "translateY(-8px)",
                    boxShadow: "0 16px 32px rgba(0,0,0,0.12)",
                  },
                  mb: { xs: 3, sm: 4 },
                  cursor: "pointer", // Add pointer cursor to entire card
                }}
                onClick={() => handlePostClick(post._id)} // Main click handler for the entire card
              >
                {/* Creator Info */}
                <Box sx={{ display: "flex", gap: 1.5, alignItems: "center", mb: 2 }}>
                  {/* Profile Picture */}
                  <Avatar
                    src={user?.picturePath ? storage.getFileView(BUCKET_ID, user.picturePath) : undefined}
                    alt={user?.firstName || "User"}
                    sx={{ 
                      width: { xs: 36, sm: 40 }, 
                      height: { xs: 36, sm: 40 }, 
                      border: "2px solid #F02C56",
                      transition: "transform 0.2s ease",
                      "&:hover": {
                        transform: "scale(1.1)"
                      }
                    }}
                  />
                  
                  {/* Username and Status */}
                  <Box sx={{ flex: 1, overflow: "hidden" }}>
                    <Typography 
                      sx={{ 
                        fontWeight: 600, 
                        fontSize: { xs: 13, sm: 14 }, 
                        color: "#1a1a1a",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis"
                      }}
                    >
                      {user?.firstName} {user?.lastName}
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: { xs: 11, sm: 12 },
                        color: "#666",
                      }}
                    >
                      Creator
                    </Typography>
                  </Box>
                  
                  {/* Talent Badge */}
                  <Box>
                    <Typography 
                      sx={{ 
                        fontSize: { xs: 11, sm: 12 }, 
                        color: "#fff",
                        fontWeight: "bold",
                        bgcolor: "#F02C56",
                        px: 1.5,
                        py: 0.5,
                        borderRadius: "12px",
                        display: "inline-block",
                        whiteSpace: "nowrap"
                      }}
                    >
                      {post.talent || "Talent"}
                    </Typography>
                  </Box>
                </Box>

                {/* Video Section */}
                {post.videoPath && (
                  <Box
                    sx={{ 
                      position: "relative", 
                      display: "flex", 
                      justifyContent: "center"
                    }}
                  >
                    <Box
                      ref={el => videoContainerRefs.current[post._id] = el}
                      sx={{
                        width: "100%",
                        borderRadius: 3,
                        overflow: "hidden",
                        background: "#000",
                        border: "1px solid rgba(255, 255, 255, 0.2)",
                        position: "relative",
                        height: { xs: "240px", sm: "280px", md: "320px" },
                        transition: "all 0.3s ease"
                      }}
                      onClick={(e) => {
                        // Video container now uses the same redirect as the parent box
                        e.stopPropagation();
                        handlePostClick(post._id);
                      }}
                    >
                      <video
                        ref={el => videoRefs.current[post._id] = el}
                        // Remove onClick handler from video element to prevent playing
                        onPlay={() => setVideoStates(prev => ({
                          ...prev,
                          [post._id]: { ...prev[post._id], playing: true }
                        }))}
                        onPause={() => setVideoStates(prev => ({
                          ...prev,
                          [post._id]: { ...prev[post._id], playing: false }
                        }))}
                        onTimeUpdate={() => handleTimeUpdate(post._id)}
                        onLoadedMetadata={() => handleMetadataLoaded(post._id)}
                        src={post.videoPath}
                        muted={videoStates[post._id]?.muted}
                        loop
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "contain",
                          cursor: "pointer",
                        }}
                      />
                      
                      {/* Play Button - Now always visible */}
                      <Box
                       sx={{
                          position: "absolute",
                          top: "50%",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                          borderRadius: "50%",
                          padding: 0,
                          cursor: "pointer",
                          animation: "pulse 1.8s infinite",
                          zIndex: 10, // Ensure it's above the video
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          handlePostClick(post._id);
                        }}
                      >
                        <AiOutlinePlayCircle size={40} color="#fff" />
                      </Box>

                      {/* Progress Bar - Updated to prevent video seeking */}
                      <Box
                        ref={el => progressBarRefs.current[post._id] = el}
                        onClick={(e) => {
                          // Prevent seeking the video, redirect instead
                          e.stopPropagation();
                          handlePostClick(post._id);
                        }}
                        sx={{
                          position: "absolute",
                          bottom: 0,
                          left: 0,
                          width: "100%",
                          height: { xs: 4, sm: 6 },
                          cursor: "pointer",
                          backgroundColor: "rgba(255,255,255,0.3)",
                          zIndex: 3,
                        }}
                      >
                        <Box
                          sx={{
                            height: "100%",
                            width: `${videoStates[post._id]?.progress || 0}%`,
                            background: "linear-gradient(to right, #F02C56, #FF6A88)",
                            transition: "width 0.2s ease",
                            borderRadius: "0 4px 4px 0",
                          }}
                        />
                      </Box>
                    </Box>
                  </Box>
                )}
                
                {/* Description */}
                <Box sx={{ mt: 2, px: 0.5 }}>
                  <Typography sx={{ 
                    fontSize: { xs: 14, sm: 15 }, 
                    color: "#333", 
                    fontWeight: 500,
                    mb: 1,
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    lineHeight: 1.4
                  }}>
                    {post.description || "No description"}
                  </Typography>
                  
                  {/* Hashtags if available */}
                  {post.description && (
                    <Box 
                      sx={{ 
                        fontSize: { xs: 12, sm: 13 }, 
                        color: "#2196f3", 
                        mt: 0.5, 
                        mb: 1,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis"
                      }}
                    >
                      {post.description.match(/#\w+/g)?.map((tag, i) => (
                        <span key={i} style={{ marginRight: 6, cursor: "pointer" }}>
                          {tag}
                        </span>
                      ))}
                    </Box>
                  )}
                  
                  {/* Created Date */}
                  <Typography sx={{ 
                    fontSize: { xs: 10, sm: 11 }, 
                    color: "#888", 
                    mt: 1,
                    fontStyle: "italic" 
                  }}>
                    Created on: {new Date(post.createdAt).toLocaleDateString()}
                  </Typography>
                  
                  {/* Delete Button - Updated to open confirmation dialog */}
                  <Box
                    onClick={(e) => openDeleteDialog(post._id, e)}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 1,
                      mt: 2,
                      py: 1,
                      px: { xs: 2, sm: 3 },
                      borderRadius: 8,
                      bgcolor: "rgba(240, 44, 86, 0.1)",
                      color: "#F02C56",
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                      "&:hover": {
                        bgcolor: "rgba(240, 44, 86, 0.2)",
                        transform: "translateY(-2px)"
                      }
                    }}
                  >
                    <DeleteOutline fontSize="small" />
                    <Typography sx={{ 
                      fontSize: { xs: 12, sm: 13 }, 
                      fontWeight: 500 
                    }}>
                      Delete Video
                    </Typography>
                  </Box>
                </Box>
              </Box>
            ))}
          </Box>
        )}
        
        {/* Footer/Info Section */}
        {posts.length > 0 && (
          <Box 
            sx={{ 
              width: "100%", 
              maxWidth: "800px", 
              textAlign: "center", 
              mt: { xs: 4, sm: 6 },
              mb: 2,
              px: 2
            }}
          >
            <Typography 
              variant="body2" 
              sx={{ 
                color: "#888", 
                fontSize: { xs: 12, sm: 13 }
              }}
            >
              Showing {posts.length} {posts.length === 1 ? 'video' : 'videos'}
            </Typography>
          </Box>
        )}
      </Box>

      {/* Delete Confirmation Dialog */}
      <Dialog
        open={deleteDialogOpen}
        onClose={closeDeleteDialog}
        PaperProps={{
          sx: {
            borderRadius: 3,
            padding: 1,
            maxWidth: { xs: "90%", sm: "450px" }
          }
        }}
      >
        <DialogTitle sx={{ 
          display: "flex", 
          alignItems: "center", 
          gap: 1.5,
          borderBottom: "1px solid rgba(0,0,0,0.1)",
          pb: 2
        }}>
          <Warning sx={{ color: "#F02C56" }} />
          <Typography sx={{ fontWeight: 600, fontSize: { xs: 18, sm: 20 } }}>
            Confirm Video Deletion
          </Typography>
        </DialogTitle>
        
        <DialogContent sx={{ mt: 2, py: 1 }}>
          <Typography sx={{ fontSize: { xs: 14, sm: 16 }, color: "#555" }}>
            Are you sure you want to delete this video? This action cannot be undone.
          </Typography>
          
          <Box sx={{ 
            mt: 3, 
            display: "flex", 
            alignItems: "center", 
            gap: 2, 
            padding: 2, 
            borderRadius: 2, 
            bgcolor: "rgba(240, 44, 86, 0.1)" 
          }}>
            <DeleteOutline sx={{ color: "#F02C56" }} />
            <Typography sx={{ 
              fontSize: { xs: 13, sm: 14 }, 
              color: "#333", 
              fontWeight: 500 
            }}>
              Deleted videos cannot be recovered. All views, comments, and interactions will be permanently lost.
            </Typography>
          </Box>
        </DialogContent>
        
        <DialogActions sx={{ 
          display: "flex", 
          justifyContent: "space-between", 
          px: 3, 
          pb: 3, 
          pt: 1 
        }}>
          <Button
            onClick={closeDeleteDialog}
            sx={{
              px: 3,
              py: 1,
              borderRadius: 8,
              color: "#555",
              border: "1px solid rgba(0,0,0,0.15)",
              "&:hover": {
                backgroundColor: "rgba(0,0,0,0.05)"
              }
            }}
          >
            Cancel
          </Button>
          
          <Button
            onClick={confirmDelete}
            sx={{
              px: 3,
              py: 1,
              borderRadius: 8,
              bgcolor: "#F02C56",
              color: "white", 
              "&:hover": {
                bgcolor: "#d12a4f"
              }
            }}
          >
            Delete Video
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default MyUploads;
